import { globalHive } from '../../src/modules/hive'
import { syncAll } from '../../src/redux/actions/entities'
import { Acti_initialise } from '../Acti/Acti.initialise'
import { DS_setData } from '../DS/DS.Data'
import { IDB_calendarEventsWrite } from '../IDB/IDB.table.calendarEvent'
import { IDB_fixesWrite } from '../IDB/IDB.table.fix'
import { IDB_reportsWrite } from '../IDB/IDB.table.report'
import { IDB_taskReportsWrite } from '../IDB/IDB.table.taskReport'
import type { Imag_LegacyFile } from '../Imag/Imag.LegacyFile'
import { LS_userSet } from '../LS/LS.user'
import type { NReports } from '../Rpts/Rpts.types'
import type { Type_ICalendarEvent, Type_IFix, Type_ITaskReport } from '../Type/Type.hive'
import type { User_IUser } from '../User/User.IUser'
import {
    type Rpts_LegacyBackups,
    type Rpts_OpenReport,
    Rpts_openReportRestoreFromBackups,
    Rpts_openReportWrite,
} from '../Rpts/Rpts.OpenReport'
import { QuietClientLogger } from '../../../shared/lib/ClientLogger.no-deps'

export interface Sett_DataDump {
    version: string
    storage: string
    tables: {
        reports: NReports.TDatabaseReport[]
        fixes: Type_IFix[]
        task_report: Type_ITaskReport[]
        files: Imag_LegacyFile[]
        backup?: Rpts_LegacyBackups
        openReport?: Rpts_OpenReport
        calendar_events: Type_ICalendarEvent[]
    }
    localStorage: {
        user: User_IUser
    }
}

/**
 * Sett.loadDataDump
 *
 * This is a dirty script to try to recreate a users setup from a data dump.
 * It is mainly used to manually upload reports that are failing to upload,
 * or to diagnose what's going wrong.
 * It is completely blind to schema changes and app versioning and really should
 * be improved upon.
 */
export async function Sett_loadDataDump() {
    const logger = new QuietClientLogger()

    // Upload dump with dialog
    const json = await new Promise<string>((resolve, reject) => {
        const element = document.createElement('input')
        element.type = 'file'
        element.onchange = () => {
            if (element.files.length === 0) {
                reject(new Error('No files selected'))
            }
            const reader = new FileReader()
            reader.onerror = () => reject(reader.error)
            reader.onload = () => resolve(reader.result as string)
            reader.readAsText(element.files[0])
        }
        element.click()
    })

    // It's double serialized for some reason
    const dataDump: Sett_DataDump = JSON.parse(JSON.parse(json).string)

    // Copy over user
    LS_userSet(dataDump.localStorage.user)

    // Copy tables
    await Promise.all([
        IDB_reportsWrite(logger, dataDump.tables.reports),
        IDB_fixesWrite(dataDump.tables.fixes),
        IDB_taskReportsWrite(dataDump.tables.task_report),
        dataDump.tables.backup
            ? Rpts_openReportRestoreFromBackups(dataDump.tables.backup)
            : Rpts_openReportWrite(dataDump.tables.openReport),
        IDB_calendarEventsWrite(dataDump.tables.calendar_events),
    ])

    // Load data into memory
    DS_setData('UserFetched', () => ({ user: dataDump.localStorage.user }))
    globalHive.dispatch(syncAll())
    Acti_initialise(globalHive)
}
